//热力图方案图层构造
import { getDispatcher } from '@/utils/analysisTools/';
import WFSBean from '@/utils/analysisTools/beans/WFSBean';

import HeatMapLayer from '../components/HeatMapLayer.js';

export default {
    //检查参数是否完整
    checkParameter(json) {
        try {
            const parameter = {};
            parameter.zoomRange = json.configcont.basic.zoomRange;

            const thematic = json.configcont.thematic;
            parameter.url = thematic.serviceUrl;
            parameter.layerName = thematic.serviceLayer;
            parameter.colors = thematic.colors;
            parameter.radius = thematic.radius;
            // parameter.weightField = thematic.weightField

            for (const values of Object.values(parameter)) {
                if (values === undefined) {
                    return false;
                }
            }
            return parameter;
        } catch {
            return false;
        }
    },
    getColors(colors) {
        const temp = [
            'interpolate',
            ['linear'],
            ['heatmap-density'],
            0,
            'rgba(33,102,172,0)',
            0.2,
            'rgb(0,0,255)',
            0.4,
            'rgb(0,255,0)',
            0.6,
            'rgb(255,255,0)',
            0.8,
            'rgb(255,255,0)',
            1,
            'rgb(255,0,0)',
        ];

        for (let i = 0, j = 6; i < colors.length; i++, j++) {
            temp[j + i] = colors[i];
        }
        return temp;
    },
    async initLayer(
        vm,
        url,
        layerName,
        zoomRange,
        colors,
        radius,
        weightField
    ) {
        const MapView = vm.MapView;

        const queryParams = {
            url: url,
            layerName: layerName,
        };
        const _colors = this.getColors(colors);
        const bean = new WFSBean(queryParams);
        return new Promise((resolve, reject) => {
            getDispatcher(vm)
                .read(bean)
                .then(result => {
                    const features = result.geojson;
                    let _weight = null;
                    if (weightField !== undefined && weightField !== '') {
                        _weight = ['get', weightField];
                        for (let i = 0; i < features.length; i++) {
                            const feature = features[i];
                            feature.properties[weightField] = Number(
                                feature.properties[weightField]
                            );
                        }
                    }
                    const wfsLayer = new HeatMapLayer('custom', zoomRange);
                    wfsLayer.setMap(MapView.map);
                    wfsLayer.setData(features);
                    wfsLayer.Styles = {
                        heat: {
                            'heatmap-radius': radius,
                            'heatmap-color': _colors,
                            'heatmap-weight': _weight,
                        },
                    };

                    resolve(wfsLayer);
                })
                .catch(() => {
                    vm.$Message.error('方案数据解析失败，请检查数据配置！');
                    reject();
                });
        });
    },
};
